import { useMemo } from 'react';
import dayjs, { Dayjs, max } from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import { useAuth } from 'contexts';
import { TDataBaseObjectClasseNames } from 'types/otkTypes';

dayjs.extend(minMax);

const DEFAULT_CLOSE_DATE = dayjs('1900-01-01');

export const useDocCloseDate = (docType: TDataBaseObjectClasseNames): Dayjs => {
  const { options, lab } = useAuth();

  return useMemo(() => {
    const gridOptions = options?.closeByDocs?.grid.find((r) => r.docType === docType);
    const dates = [
      gridOptions?.period,
      gridOptions?.byOrgs.find((r) => r.organization === lab?.organization)?.date,
    ]
      .filter(Boolean)        // лише заповнені
      .map((d) => dayjs(d));  // приводимо формат в dayjs

    return max(dates) ?? DEFAULT_CLOSE_DATE;
  }, [ options, lab, docType ]);
};
